<template>
  <MainNavbar class="edu-fixed-nav" />
  <ContactUs />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import ContactUs from "../components/Contact/ContactUs.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "RegisterPage",
  components: {
    MainNavbar,
    ContactUs,
    MainFooter,
  },
});
</script>
